import React from "react";
import LoginForm from "user/authentication/ui/forms/LoginForm";
// Router
import * as appRouting from "appRouting";
import { Link } from "react-router";
// Bootstrap
import { Panel } from "react-bootstrap";
import AuthContainer from "user/authentication/ui/views/components/AuthContainer";
import AuthFooter from "user/authentication/ui/views/components/AuthFooter";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./AuthenticationView.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export const LoginView = () => {
    return (React.createElement(AuthContainer, { isLarge: false },
        React.createElement(Panel, null,
            React.createElement(Panel.Heading, null,
                React.createElement("span", { className: styles.logo })),
            React.createElement(Panel.Body, null,
                React.createElement(LoginForm, null)),
            React.createElement(Panel.Footer, null,
                React.createElement(AuthFooter, null,
                    "Not a member? ",
                    React.createElement(Link, { to: appRouting.requestVerifyPath() }, "Join Now")),
                React.createElement(AuthFooter, null,
                    React.createElement(Link, { to: appRouting.forgotPasswordPath() }, "Forgot your password?"))))));
};
